import { FC, MouseEventHandler } from 'react'
import { Link as LinkR } from 'react-router-dom'

import './style.scss'

type LinkProps = {
  className?: string,
  style?: any,
  to?: string,
  color?: string,
  size?: number,
  onClick?: MouseEventHandler<HTMLAnchorElement | HTMLButtonElement>
}

const Link:FC<LinkProps> = ({ children, className = '', style, to = '', color = 'gray-700', size, onClick, ...rest })  => {
  return (
    <>
      {to ?
          <LinkR to={to} className={`link ${color ? 'text-' + color : ''} ${size ? 'fz-' + size : ''} ${className}`} onClick={onClick} style={style} {...rest}>{children}</LinkR>
        :
          <button className={`link ${color ? 'text-' + color : ''} ${size ? 'fz-' + size : ''} ${className}`} style={style} onClick={onClick} {...rest}>{children}</button>
      }
    </>
  )
}

export { Link }